import React from 'react'
import Features from './Features'

const WhatGPT3 = () => {
  return (
    <div id="wgpt3" className='px-10 py-4 mt-10'>
      <div className='grid md:grid-cols-2 gap-10'>
        <div className='bg-clip-text text-transparent bg-gradient-to-r from-[#AE67FA] to-[#F49867]'>
          <h1 className='text-2xl md:text-3xl'>The Future is Now and You Just Need To Realise it.Step into Future to Make it Happen.</h1>
          <p className='mt-6'>Register Early Acess to Get Started</p>
        </div>
        <div className='mt-2 md:mt-none'>
          <Features title="Improving and distract actively" text="the process by which living things survive is not up to humans to decide the god's"/>
          <Features title="Become the tendered active" text="the process by which living things survive is not up to humans to decide the god's"/>
          <Features title="Message or am nothing" text="the process by which living things survive is not up to humans to decide the god's"/>
          <Features title="Discord call or am nothing" text="the process by which living things survive is not up to humans to decide the god's"/>
        </div>
      </div>
    </div>
  )
}

export default WhatGPT3